<template>
  <div>
    <h3>Project Showcase</h3>
    <div class="h4 py-5">
      CSR內頁列表，你可以直接於此新增/編輯/刪除，若需要編輯順序，請點此頁上方的編輯按鈕。
    </div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in csr.projects"
        :key="i"
      >
        <div
          class="w-40px h-40px bg-cover bg-center bg-c"
          :style="{
            'background-image': `url(${item.image})`,
          }"
        ></div>
        <div class="h4 ml-5">{{ item.title }}</div>
        <div class="ml-auto">
          <button class="btn square ml-auto ml-10px" @click="editItem(item)">
            <v-icon>edit</v-icon>
          </button>
          <button class="btn square ml-10px" @click="deleteItem(item)">
            <v-icon>delete</v-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- add item -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem()">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加 CSR Project</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    csr: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        imageUrl:
          'https://images.unsplash.com/photo-1560698711-6df2370d7d62?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
        title: '抗硫化技術',
        isStar: false,
      },
      {
        id: '002',
        imageUrl: '',
        title: 'Project Name1',
        isStar: true,
      },
      {
        id: '003',
        imageUrl: '',
        title: 'Project Name2',
        isStar: false,
      },
      {
        id: '004',
        imageUrl: '',
        title: 'Project Name3',
        isStar: false,
      },
      {
        id: '005',
        imageUrl: '',
        title: 'Project Name4',
        isStar: false,
      },
    ],
  }),
  methods: {
    ...mapActions({
      setCsr: 'csr/setCsr',
      initProjectDetail: 'csr/initProjectDetail',
      deleteProject: 'csr/deleteProject',
    }),
    addItem() {
      const detail = {
        title: '',
        image: '',
        description: '',
        content: [],
      };
      this.setCsr(null);
      this.initProjectDetail(detail);
      this.$router.push({
        path: '/csr-page/edit/project-show-case',
      });
    },
    editItem(detail) {
      this.setCsr(null);
      this.initProjectDetail(detail);
      this.$router.push({
        path: '/csr-page/edit/project-show-case',
      });
    },
    async deleteItem(item) {
      await this.deleteProject(item.id).then(() => {
        const index = this.csr.projects.map((option) => option.id).indexOf(item.id);
        this.csr.projects.splice(index, 1);
      });
    },
  },
};
</script>

<style></style>
